export function useTelegram() {
    const webApp = window.Telegram.WebApp
    const user = webApp.initDataUnsafe?.user
    const lang = webApp.initDataUnsafe?.user?.language_code === 'ru' ? 'ru' : 'en'
    return {
        webApp,
        user,
        lang
    }
};